export type MicrophoneGainMode = "provider-default" | "automatic" | "manual";

export type MicrophoneGainStatus = "idle" | "active" | "fallback" | "unavailable";

export const DEFAULT_MICROPHONE_GAIN_MODE: MicrophoneGainMode = "provider-default";
export const DEFAULT_MANUAL_MICROPHONE_GAIN = 1;
export const MIN_MANUAL_MICROPHONE_GAIN = 0.5;
export const MAX_MANUAL_MICROPHONE_GAIN = 2;
export const MANUAL_MICROPHONE_GAIN_STEP = 0.05;

export function clampManualMicrophoneGain(value: number): number {
    if (!Number.isFinite(value)) {
        return DEFAULT_MANUAL_MICROPHONE_GAIN;
    }

    return Math.min(MAX_MANUAL_MICROPHONE_GAIN, Math.max(MIN_MANUAL_MICROPHONE_GAIN, value));
}
